// extracted by mini-css-extract-plugin
export default {"priceWrapper":"OfferPriceBlock_priceWrapper__sn0j5","price":"OfferPriceBlock_price__fGJyz","payButton":"OfferPriceBlock_payButton__8LHKx"};